import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=32f171e7&scoped=true&"
import script from "./TermsConditions.vue?vue&type=script&lang=js&"
export * from "./TermsConditions.vue?vue&type=script&lang=js&"
import style0 from "./TermsConditions.vue?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/success.css?vue&type=style&index=1&id=32f171e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f171e7",
  null
  
)

export default component.exports